import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import styles from "./index.module.less";
import { Form, FormInstance, Input } from "antd";
import type { EvaluationAdviceFiledType } from "../../type";
import { useTranslation } from "react-i18next";

type Props = {
  form: FormInstance<EvaluationAdviceFiledType>;
  disabled: boolean;
};

export const PerformanceEvaluationAdvice: React.FC<Props> = ({
  form,
  disabled,
}) => {
  const { t } = useTranslation("supplierPerformance");

  return (
    <div className={styles.card}>
      <ModalSectionHeader title={t("供应商改进和激励举措")} />
      <Form
        form={form}
        initialValues={{ evaluationAdvice: "" }}
        disabled={disabled}
      >
        <Form.Item
          name="evaluationAdvice"
          rules={[
            {
              required: true,
              message: t("请填写供应商改进和激励举措"),
            },
          ]}
        >
          <Input.TextArea
            rows={5}
            placeholder={t("请填写供应商改进和激励举措")}
            maxLength={1000}
          />
        </Form.Item>
      </Form>
    </div>
  );
};
